exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.help-link{margin-bottom:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/helpLink.scss
// module id = 977
// module chunks = 0